"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var Stores = require("../store/ConfirmStatusApplication");
var reactstrap_1 = require("reactstrap");
var ModalConfirmStatusApplicationComponent = /** @class */ (function (_super) {
    __extends(ModalConfirmStatusApplicationComponent, _super);
    function ModalConfirmStatusApplicationComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            pageLoad: true,
            isOpen: false,
            isRegisClick: false,
            isOpenAlert: false,
            isAction: false,
            classSpinner: "d-none"
        };
        _this.toggleModal = _this.toggleModal.bind(_this);
        _this.acceptClick = _this.acceptClick.bind(_this);
        _this.rejectClick = _this.rejectClick.bind(_this);
        return _this;
    }
    ModalConfirmStatusApplicationComponent.prototype.toggleModal = function () {
        this.setState({
            isOpen: !this.state.isOpen,
            classSpinner: "d-none"
        });
        if (!this.state.isOpen) {
            this.props.afterCloseModal();
        }
    };
    ModalConfirmStatusApplicationComponent.prototype.acceptClick = function () {
        this.props.requestFunction(this.state.pageLoad, this.props.appUUID, "PUT");
        this.setState({
            isAction: true,
            classSpinner: "d-inline-block"
        });
    };
    ModalConfirmStatusApplicationComponent.prototype.rejectClick = function () {
        this.props.requestFunction(this.state.pageLoad, this.props.appUUID, "DELETE");
        this.setState({
            isAction: true,
            classSpinner: "d-inline-block"
        });
    };
    ModalConfirmStatusApplicationComponent.prototype.togglAlert = function () {
        this.setState({
            isOpen: !this.state.isOpen
        });
    };
    ModalConfirmStatusApplicationComponent.prototype.render = function () {
        if (this.props.isOpenModal) {
            this.toggleModal();
            this.props.afterOpenModal();
        }
        if (this.props.isLoading && this.state.isAction) {
            if (this.props.message == 200) {
                console.log("success");
                this.toggleModal();
                this.props.BindData();
                this.setState({
                    isAction: false
                });
            }
            else {
                console.log("fail");
                this.setState({
                    isAction: false
                });
            }
        }
        return (React.createElement("div", null,
            React.createElement(reactstrap_1.Modal, { isOpen: this.state.isOpen },
                React.createElement(reactstrap_1.ModalHeader, { toggle: this.toggleModal },
                    "Confirm ",
                    this.props.typeClick),
                React.createElement(reactstrap_1.ModalBody, null,
                    React.createElement("p", { style: { fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif" } },
                        "Are you sure to ",
                        this.props.typeClick,
                        " App [ ",
                        this.props.appName,
                        " ]?")),
                React.createElement(reactstrap_1.ModalFooter, null,
                    this.props.typeClick == "Accept" ?
                        React.createElement(reactstrap_1.Button, { color: "primary", onClick: this.acceptClick },
                            React.createElement(reactstrap_1.Spinner, { color: "primary", className: this.state.classSpinner, style: { width: '20px', height: '20px' } }),
                            ' ',
                            "Accept")
                        :
                            React.createElement(reactstrap_1.Button, { color: "danger", onClick: this.rejectClick },
                                React.createElement(reactstrap_1.Spinner, { color: "danger", className: this.state.classSpinner, style: { width: '20px', height: '20px' } }),
                                ' ',
                                "Reject"),
                    React.createElement(reactstrap_1.Button, { color: "secondary", onClick: this.toggleModal }, "Close")))));
    };
    return ModalConfirmStatusApplicationComponent;
}(React.PureComponent));
exports.default = react_redux_1.connect(function (state) { return state.confirmStatusApplication; }, Stores.actionCreators)(ModalConfirmStatusApplicationComponent);
//# sourceMappingURL=ModalConfirmStatusApplicationComponent.js.map